import React, {Component} from 'react';
import {importFromXlsx} from '../xlsxUtils';

export default class extends Component {

    render() {
        return <div className={this.props.className}>
            {this.props.children ? this.props.children : ''}
            <input type="file" accept=".xlsx" onChange={event => this.onChange(event)} />
        </div>;
    }

    run() {
        this.el.addEventListener('change', event => this.onChange(event), false);
    }

    onChange(event) {
        const files = event.target.files, f = files[0];
        importFromXlsx(f).then(data => this.props.onData(data)).catch(e => this.props.onError(e));
    }

}



// WEBPACK FOOTER //
// ./src/HrcsEditor/input/UploadInput.js